<template>
    <div>
        <compFormEdit
            :labelWidth="150"
            ref="form"
            class="margin-right-15 margin-top-15"
            :formdata="getBase"
            :inboundPlanOrderId="inboundPlanOrderId"
            v-model="formData"
        ></compFormEdit>
        <footer class="text-right margin-top-10">
            <Button type="primary"
                    @click="submit">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</Button>
            <Button class="margin-left-10"
                    @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
        </footer>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import {
        HttpModifyDateInbound,HttpInboundBill
    } from '@/service/inbound';
    export default {
        props: ['inboundPlanOrderId','alertbox'],
        components: {
        },
        data () {
            return {
                loading: false,
                formData: {

                },
                submitData:{},
            }
        },
        computed: {
            getBase(){
                return [{
                    tag: "vDatepicker",
                    key: 'expectArriveDate',
                    labelWidth: 'auto',
                    span: 24,
                    label: this.$t('fbb.inbound.expect_arrivaldate', { defaultValue: '期望到货日期' }),
                    props: {
                        format: 'yy-mm-dd',
                        confirm: false,
                    },
                    style: "width:361px",
                },
                    {
                        tag: "vDatepicker",
                        key: 'predictionShipDate',
                        labelWidth: 'auto',
                        span: 24,
                        label: this.$t('fbb.inbound.expect_deliverydate', { defaultValue: '预计发货日期' }),
                        props: {
                            format: 'yy-mm-dd',
                            confirm: false,
                        },
                        style: "width:361px",
                    }
                ]
            },
            //管理端
            isManage() {
                return this.manageuse === "manage"
            },
        },
        created () {
            this.getDetail();
        },
        methods: {
            async getDetail() {
                this.loading = true;
                HttpInboundBill({ id: this.inboundPlanOrderId }).then(res => {
                    this.loading = false;
                    this.formData = res.data;
                    this.$set(this.formData,"serviceCodes",this.formData.serviceCode);
                }).catch(err => {
                    this.loading = false;
                })
            },
            async submit() {
                let validate = await this.$refs.form.validate();
                if (!validate) return;
                this.loading = true;
                this.submitData={"id":this.formData.id,"expectArriveDate":this.formData.expectArriveDate,"predictionShipDate":this.formData.predictionShipDate}
                HttpModifyDateInbound(this.submitData).then(res => {
                    this.$VMessage.success("修改成功");
                    if (this.alertbox) {
                        this.$emit('on-close')
                    } else {
                        const name = this.$route.name;
                        this.$router.push({
                            name: this.isManage ? 'inboundBillmanage' : 'inboundBillclient'
                        })
                    }
                }).catch(err => {
                    this.loading = false;
                    this.$VMessage.error(err.message)
                })
            },
            cancel(){
                if (this.alertbox) {
                    this.$emit('on-close')
                } else {
                    const name = this.$route.name;
                    this.$router.push({
                        name: this.isManage ? 'inboundBillmanage' : 'inboundBillclient'
                    })
                }
            },
        }
    }
</script>
